import React, { useEffect, useState } from 'react'
import Tabs from 'components/shared/Tabs'
// import useGetAllIndexesByMutation from 'sdk/hooks/search/useGetAllIndexesByQuery'
import styles from './styles.module.scss'
import Assets from './Assets'
import Hashtags from './Hashtags'
import Users from './Users'
import Videos from './Videos'
import NotFound from './NotFound'

enum View { All, Stocks, ETFs, Crypto, NFT }
const items = [
  { title: 'All', id: View.All },
  { title: 'Stocks', id: View.Stocks },
  { title: 'ETFs', id: View.ETFs },
  { title: 'Crypto', id: View.Crypto },
]

type Props = { search: string }

export function TabTrending({
  search,
}: Props) {
  const [view, setView] = useState<View>(View.All)
  const [assetsNotFound, setAssetsNotFound] = useState<boolean>(false)
  const [hashtagsNotFound, setHashtagsNotFound] = useState<boolean>(false)
  const [usersNotFound, setUsersNotFound] = useState<boolean>(false)
  const [videosNotFound, setVideosNotFound] = useState<boolean>(false)
  const selectedCategory = items?.find((i) => i.id === view)?.title

  useEffect(() => {
    if (search !== undefined) {
      // getAll({ query: search, category: selectedCategory === 'All' ? '' : selectedCategory })
    }
  }, [search, view])

  return (
    <div>
      <Tabs
        className={styles.tabs}
        items={items}
        onSelect={setView}
        value={view}
        simple
      />

      <Assets search={search} selectedCategory={selectedCategory} setNotFound={setAssetsNotFound} />
      <Hashtags
        search={search}
        selectedCategory={selectedCategory}
        setNotFound={setHashtagsNotFound}
      />
      <Users search={search} selectedCategory={selectedCategory} setNotFound={setUsersNotFound} />
      <Videos
        search={search}
        selectedCategory={selectedCategory}
        title="Videos"
        setNotFound={setVideosNotFound}
      />
      {
        assetsNotFound
        && hashtagsNotFound
        && usersNotFound
        && videosNotFound
        && <NotFound text="Unfortunately, nothing was found" />
      }
    </div>
  )
}
